<style lang="scss">
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/colors";

  button.toggle {
    $toggle-width: utils.in_rem(36px);
    $toggle-height: utils.in_rem(20px);
    $slider-size: utils.in_rem(16px);
    $slider-margin: utils.in_rem(1px);
    $slider-transition-time: 0.2s;

    width: $toggle-width;
    height: $toggle-height;
    display: inline-flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    flex-shrink: 0;
    border: none;
    background: none;
    padding: 0;

    &.disabled {
      pointer-events: none;

      input {
        &:checked + .slider {
          background-color: colors.get(interfaceSwGrey_20);
          border-color: colors.get(interfaceSwGrey_20);

          &:before {
            background-color: colors.get(interfaceTransparentWhite_70);
            left: calc(100% - $slider-size - $slider-margin);
          }
        }
      }

      .slider {
        border-color: colors.get(interfaceSwGrey_10);

        &:before {
          background-color: colors.get(interfaceSwGrey_20);
        }
      }
    }

    input {
      width: 0;
      height: 0;
      opacity: 0;
      position: absolute;

      &:checked + .slider {
        background-color: colors.get(primary_50);
        border-color: colors.get(primary_50);

        &:before {
          background-color: colors.get(primary_5);
          left: calc(100% - $slider-size - $slider-margin);
        }
      }

      &:checked:hover + .slider {
        background-color: colors.get(primary_30);
        border-color: colors.get(primary_30);

        &:before {
          background-color: colors.get(primary_5);
          left: calc(100% - $slider-size - $slider-margin);
        }
      }

      &:checked:focus + .slider {
        background-color: colors.get(primary_30);
        border-color: colors.get(primary_40);
        outline: 1px solid colors.get(primary_40);

        &:before {
          background-color: colors.get(primary_5);
          left: calc(100% - $slider-size - $slider-margin);
        }
      }

      &:hover + .slider {
        outline: 0;
        background-color: colors.get(interfaceSwGrey_10);
        &:before {
          background-color: colors.get(primary_50);
        }
      }

      &:focus + .slider {
        outline: 1px solid colors.get(primary_40);
        border-color: colors.get(primary_40);
        background-color: colors.get(primary_20);
        &:before {
          background-color: colors.get(interfaceSwShadowGrey);
        }
      }
    }

    .slider {
      background-color: colors.get(interfaceSwGrey_10);
      border: 1px solid colors.get(interfaceTransparentBlack_30);
      border-radius: utils.in_rem(100px);
      bottom: 0;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      transition: $slider-transition-time;

      &:before {
        background-color: colors.get(interfaceSwShadowGrey);
        border-radius: utils.in_rem(100px);
        content: "";
        left: $slider-margin;
        position: absolute;
        transition: $slider-transition-time;
        top: 50%;
        transform: translateY(-50%);
        width: $slider-size;
        height: $slider-size;
      }
    }
  }
</style>

<script>
  export let checked = false;
  export let disabled = false;
  export let label = "Toggle";
  export let onChange = () => {}; // Callback for when the toggle changes

  const toggle = () => {
    checked = !checked;
    onChange(checked);
  };

  const handleKeydown = (event) => {
    if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      toggle();
    }
  };
</script>

<button
  type="button"
  class="toggle"
  class:disabled
  role="switch"
  aria-checked={checked}
  {disabled}
  on:click={toggle}
  on:keydown={handleKeydown}
  aria-label={label}
>
  <input
    type="checkbox"
    bind:checked
    {disabled}
    aria-hidden="true"
    tabindex="-1"
  />
  <span class="slider"></span>
</button>
